import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel as Lightbox } from 'react-responsive-carousel';

const customStyles = {
    content: {
        background: 'none',
        padding: 0,
        border: 'none',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)',
        zIndex: 2003,
    },
};
const LightboxSettings = {
    showStatus: false,
    showIndicators: false,
    useKeyboardArrows: true,
    thumbWidth: 50,
    autoPlay: false,
    autoFocus: true,
};

const renderThumbnails = (children) => {
    const images = children.map((item, index) => {
        if (!item || !item.props || !item.props.children) {
            return undefined;
        }

        // find img to get source
        const imageElement = item.props.children.find(
            (ele) => ele.type === 'img'
        );
        if (!imageElement || !imageElement.props || !imageElement.props.src) {
            return undefined;
        }

        return (
            <div
                key={index}
                style={{
                    backgroundImage: 'url(' + imageElement.props.src + ')',
                }}
                className="thumbnail__image"
            />
        );
    });

    return images;
};

const LightboxImages = ({ images, flag, emblem, container }) => {
    const onClose = () => setVisible(false);
    const onClickThumbnail = (index) => {
        setVisible(true);
        setIndex(index);
    };
    const [selectedIndex, setNewIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (container) {
            container.classList.remove('product-images__placeholder-height');
        }
    }, [container]);

    const RenderEmblem = ({ emblem }) => {
        if (!emblem) {
            return null;
        }
        return (
            <>
                {emblem.image ? (
                    <div className="product-images__emblem-image">
                        <img src={emblem.image} alt="Product Emblem" />
                    </div>
                ) : (
                    <div
                        className="product-images__emblem"
                        style={{
                            backgroundColor: emblem.backgroundColor,
                        }}
                    >
                        {emblem && (
                            <p style={{ color: emblem.textColor }}>
                                {emblem.text}
                            </p>
                        )}
                    </div>
                )}
            </>
        );
    };

    return (
        images?.length > 0 && (
            <>
                <div className="row product-images">
                    <div className="small-12 large-12 columns product-images--main">
                        <figure className="product-detail__image-container">
                            <a
                                data-src={images[selectedIndex].src}
                                href="#"
                                itemProp="url"
                                onClick={(e) => {
                                    e.preventDefault();
                                    onClickThumbnail(selectedIndex);
                                }}
                                className="product-detail__image-container--main-image"
                                rel="nofollow"
                                dangerouslySetInnerHTML={{
                                    __html: images[selectedIndex].html,
                                }}
                            ></a>

                            {flag && (
                                <div
                                    className="product-images__flag"
                                    style={{
                                        backgroundColor: flag.backgroundColor,
                                    }}
                                >
                                    <div>
                                        <p style={{ color: flag.textColor }}>
                                            {flag.text}
                                        </p>
                                    </div>
                                    <svg height="30" width="40">
                                        <polygon
                                            points="0,0 5,0 35,15 5,30 0,30"
                                            style={{
                                                fill: flag.backgroundColor,
                                            }}
                                        />
                                    </svg>
                                </div>
                            )}

                            <RenderEmblem emblem={emblem} />
                        </figure>
                    </div>
                    <div className="small-12 large-12 columns">
                        <div className="row product-detail__thumbnail-container">
                            {images.map(
                                (image, index) =>
                                    index >= 0 && (
                                        <div
                                            className="product-detail__image-container product-detail__thumbnail-image-container"
                                            key={index}
                                        >
                                            <div className="product-detail__image-container--shadow">
                                                <a
                                                    data-src={image.src}
                                                    href="#"
                                                    itemProp="url"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setNewIndex(index);
                                                    }}
                                                    className="product-image"
                                                    rel="nofollow"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            images[index].html,
                                                    }}
                                                ></a>
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    ariaHideApp={false}
                    preventScroll={true}
                    isOpen={visible}
                    onRequestClose={onClose}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                >
                    <Lightbox
                        {...LightboxSettings}
                        selectedItem={index}
                        className="light-box"
                        renderThumbs={renderThumbnails}
                    >
                        {images.map((value, index) => (
                            <div
                                key={`figure${index}`}
                                className="light-box__container"
                            >
                                <button
                                    onClick={onClose}
                                    className="light-box__close-btn"
                                >
                                    &times;
                                </button>
                                <img
                                    src={value.src}
                                    className="light-box__image"
                                />
                            </div>
                        ))}
                    </Lightbox>
                </Modal>
            </>
        )
    );
};

export default LightboxImages;
